import { render } from "./ManageTours.vue?vue&type=template&id=d1440bbe"
import script from "./ManageTours.vue?vue&type=script&lang=js"
export * from "./ManageTours.vue?vue&type=script&lang=js"

import "./ManageTours.vue?vue&type=style&index=0&id=d1440bbe&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__